'use client';

import { memo } from 'react';
import { SkeletonCircle } from '@//components/Skeleton';
import styles from '../../../../../components/Header/Header.module.scss';

const AuthNavSkeleton = () => {
  return (
    <>
      <nav
        className={styles.savedItemsNav}
        aria-label="Loading navigation"
        data-testid="header-saved-items-nav-skeleton"
      >
        <SkeletonCircle className={styles.controlsSkeleton} />
        <SkeletonCircle className={styles.controlsSkeleton} />
      </nav>
      <SkeletonCircle
        className={styles.controlsSkeleton}
        data-testid="header-profile-avatar-skeleton"
      />
    </>
  );
};

export default memo(AuthNavSkeleton);
